import DOMPurify from 'dompurify';

export const sanitizeData = (value: string | Node) => {
    return DOMPurify.sanitize(value);
};
